exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user-in-team table th {\n  white-space: unset; }\n", ""]);

// exports
